export default __webpack_public_path__ + "static/423-f656f2179ad024999f94765c754d6d87.svg";